module.exports = __webpack_public_path__ + "static/media/meat.87a80a27.jpg";